import React from "react";
import AnswerDialog from "../../share/components/dialog/answer.dialog";
import { Box } from "@mui/material";

const OnBoarding = () => {
  const messageTitle = "⚠️ Action Not Allowed";
  const message =
    "Either you're not logged in or you've already submitted your response.";

  return (
    <>
      <AnswerDialog />
      <Box
        className="d-flex flex-column align-items-center justify-content-center"
        sx={{ height: "500px" }}
      >
        <p className="mb-1">{messageTitle}</p>
        <p>{message}</p>
      </Box>
    </>
  );
};

export default OnBoarding;
